import React, { Component } from "react";

import {
  Button,
  Wrapper,
  Row,
  Icon,
  Copy,
  Spin,
  ExternalImage
} from "app/NativeComponents/common";

import ItemHeader from "./ItemHeader";
import moment from "moment";
import {
  formatAddress,
  numberFormat,
  toTitleCase,
  determineMainOwnerInfo
} from "app/NativeActions";
import { compareTwoStrings } from "string-similarity";
import {
  determineDisplayProperty,
  formatPhoneNumber,
  skipTrace
} from "app/DealMachineCore/actions";

// { match: boolean, reason?: string }
const phoneMatch = (property, phoneData) => {
  const { owner_name: owner } = property;
  const { cnam } = phoneData;
  const THRESHOLD = 0.8;
  if (!owner || !cnam) return { match: false };
  const o = owner.toLowerCase().replace(/[^a-z ]/gi, "");
  const c = cnam.toLowerCase().replace(/[^a-z ]/gi, "");
  const [o_s, c_s] = [o.split(" "), c.split(" ")];
  const sims = [];
  for (let i = 0; i < o_s.length; i++) {
    for (let j = 0; j < c_s.length; j++) {
      sims.push(compareTwoStrings(o_s[i], c_s[j]));
    }
  }
  const ownerMatch = Math.max(...sims) > THRESHOLD;

  if (phoneData.do_not_call) return { match: false, reason: "DNC List" };
  if (phoneData.is_litigator) return { match: false, reason: "Litigator" };
  if (phoneData.blocked) return { match: false, reason: "Blocked" };
  if (!ownerMatch) return { match: false };

  return { match: true };
};
class PropertyItemAddresses extends Component {
  constructor(props) {
    super(props);

    this.state = {
      force_reload: false,
      temp_item_id: null,
      temp_item: null,

      row_height: props.toggle_lead_images ? 100 : 35
    };

    this.adjustColumnWidth = this.adjustColumnWidth.bind(this);
  }

  updateAllRefs() {
    this._row_refs = {};
    this._row_refs.deal_status = !this._row_refs.deal_status
      ? {}
      : this._row_refs.deal_status;
    this._row_refs.lists = !this._row_refs.lists ? {} : this._row_refs.lists;
    this._row_refs.tags = !this._row_refs.tags ? {} : this._row_refs.tags;
    this._row_refs.mailing_options = !this._row_refs.mailing_options
      ? {}
      : this._row_refs.mailing_options;

    if (this.props.list_properties) {
      for (let i = 0; i < this.props.list_properties.length; i++) {
        if (this.props.list_properties[i].deal) {
          this._row_refs.deal_status[
            this.props.list_properties[i].deal.id
          ] = this._row_refs.deal_status[this.props.list_properties[i].deal.id]
            ? React.forwardRef()
            : React.createRef();
          this._row_refs.lists[this.props.list_properties[i].deal.id] = this
            ._row_refs.lists[this.props.list_properties[i].deal.id]
            ? React.forwardRef()
            : React.createRef();
          this._row_refs.tags[this.props.list_properties[i].deal.id] = this
            ._row_refs.tags[this.props.list_properties[i].deal.id]
            ? React.forwardRef()
            : React.createRef();
          this._row_refs.mailing_options[
            this.props.list_properties[i].deal.id
          ] = this._row_refs.mailing_options[
            this.props.list_properties[i].deal.id
          ]
            ? React.forwardRef()
            : React.createRef();
        }
      }
    }

    this.setState({ force_reload: true });
  }

  componentDidMount() {
    this.updateAllRefs();
  }

  componentWillUnmount() {
    clearInterval(this._resize_interval);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.force_reload === false && this.state.force_reload === true) {
      this.setState({ force_reload: false });
    }

    if (this.props.list_properties) {
      if (this.props.list_properties !== prevProps.list_properties) {
        this.updateAllRefs();
      }
    }

    if (prevProps.toggle_lead_images !== this.props.toggle_lead_images) {
      this.setState({ row_height: this.props.toggle_lead_images ? 100 : 35 });
    }
  }

  getMailingOptionsText(info, deal = null) {
    let mailing_options_text = "--";
    if (info.campaign_id && parseInt(info.campaign_id) !== 0) {
      mailing_options_text = "Campaign: " + info.campaign_title;

      if (
        parseInt(info.campaign_complete) === 1 &&
        parseInt(info.campaign_id) === parseInt(deal.campaign_id)
      ) {
        mailing_options_text += "; Campaign Complete";
      } else {
        if (
          info.campaign_step &&
          parseInt(info.campaign_step) !== 0 &&
          parseInt(info.campaign_id) === parseInt(deal.campaign_id)
        ) {
          mailing_options_text += "; Step " + info.campaign_step;
        } else {
          mailing_options_text += "; Step 1";
        }
      }
    } else if (
      (info.mail_template_id && parseInt(info.mail_template_id) !== 0) ||
      (info.template_id && parseInt(info.template_id) !== 0)
    ) {
      if (info.template_id && parseInt(info.template_id) !== 0) {
        mailing_options_text = "Template: " + info.template_name;
      } else {
        mailing_options_text = "Template: " + info.mail_template_name;
      }

      if (
        parseInt(info.resend_freq) === 0 ||
        info.resend_freq_switch === "off"
      ) {
        mailing_options_text += "; Repeat Mail Off";
      } else if (parseInt(info.resend_freq) === 1) {
        mailing_options_text += "; Repeat Mail Every Day";
      } else if (parseInt(info.resend_freq) > 1) {
        mailing_options_text +=
          "; Repeat Mail Every " + info.resend_freq + " Days";
      }
      if (
        (info.resend_freq_switch && info.resend_freq_switch === "on") ||
        (!info.resend_freq_switch && parseInt(info.resend_freq) > 0)
      ) {
        if (
          parseInt(info.resend_limit) === 0 ||
          info.resend_limit_switch === "on"
        ) {
          mailing_options_text += "; Repeating Forever";
        } else if (parseInt(info.resend_limit) === 1) {
          mailing_options_text += "; Sending Once";
        } else if (parseInt(info.resend_limit) > 0) {
          mailing_options_text += "; Sending " + info.resend_limit + " Times";
        }
      }
    }
    return mailing_options_text;
  }

  updateTempItem(item_id = null, item = null) {
    this.setState({
      temp_item_id: item_id,
      temp_item: item
    });
  }

  adjustColumnWidth({ width, slug }) {
    this.props.updateNewColumnWidth({
      slug: slug,
      width: width
    });
    clearInterval(this._resize_interval);
    this._resize_interval = setTimeout(() => {
      this.saveNewWidth(width);
    }, 1000);
  }

  saveNewWidth(width) {
    if (this.props.list_settings && !this.props.list_settings_loading) {
      let new_user_list_columns = this.props.list_settings.user_list_columns;
      for (let i = 0; i < new_user_list_columns.length; i++) {
        if (new_user_list_columns[i].slug === this.props.column_section.slug) {
          new_user_list_columns[i].width = width;
          break;
        }
      }

      this.props.updateUserListSettings({
        token: this.props.token,
        user_list_columns: new_user_list_columns,
        type: "in_background"
      });
    }
  }

  renderMainColumnImage(property) {
    if (this.props.column_section.main_column) {
      if (
        (!property.deal.image || property.deal.image === "") &&
        property.owner_name !== "" &&
        property.owner_name &&
        !this.props.toggle_lead_images
      ) {
        let image_initials = "";
        if (property.owner_firstname && property.owner_lastname) {
          if (
            property.owner_firstname.length > 0 &&
            property.owner_lastname.length > 0
          ) {
            image_initials =
              property.owner_firstname[0] + property.owner_lastname[0];
          } else if (property.owner_name.length > 1) {
            image_initials = property.owner_name[0] + property.owner_name[1];
          }
        } else if (property.owner_name.length > 1) {
          image_initials = property.owner_name[0] + property.owner_name[1];
        }
        image_initials = image_initials.toUpperCase();

        return (
          <Wrapper
            style={{
              alignItems: "center",
              justifyContent: "center"
            }}
          >
            <Wrapper
              style={{
                width: 36,
                height: 36,
                borderRadius: 18,
                backgroundColor: this.props.colors.gray_color,
                textAlign: "center",
                marginRight: 10,
                alignItems: "center",
                justifyContent: "center"
              }}
            >
              <Copy style={{ width: 36 }}>{image_initials}</Copy>
            </Wrapper>
          </Wrapper>
        );
      }

      if (this.props.toggle_lead_images) {
        if (!property.deal.image || property.deal.image === "") {
          return (
            <Wrapper
              style={{
                alignItems: "center",
                justifyContent: "center",
                width: 200,
                height: this.state.row_height + 20
              }}
            >
              <Icon size={26} icon="home" />
            </Wrapper>
          );
        }

        return (
          <Wrapper
            style={{
              alignItems: "center",
              justifyContent: "center"
            }}
          >
            <ExternalImage
              style={{
                width: 200,
                height: this.state.row_height + 20,
                borderRadius: 0,
                backgroundColor: this.props.colors.gray_color,
                marginRight: 10
              }}
              image={property.deal.image}
            />
          </Wrapper>
        );
      }

      return (
        <Wrapper
          style={{
            alignItems: "center",
            justifyContent: "center"
          }}
        >
          <ExternalImage
            style={{
              width: 36,
              height: 36,
              borderRadius: 18,
              backgroundColor: this.props.colors.gray_color,
              marginRight: 10
            }}
            image={property.deal.image}
          />
        </Wrapper>
      );
    }
  }

  renderItemFormat(value, slug, format, property = null) {
    let formatted_value = "--";

    const owner_info = determineMainOwnerInfo(property);
    if (slug.includes("phone_number")) {
      if (property.deal.phone_numbers) {
        if (this.props.column_section.column_format == "single") {
          return (
            <Copy>
              {property.deal.phone_numbers.map((phone_number, i) => {
                if (i === 0) {
                  return phone_number;
                }
                return ", " + phone_number;
              })}
            </Copy>
          );
        }
        if (
          property.deal.phone_numbers.length > 0 &&
          Array.isArray(property.deal.phone_numbers)
        ) {
          const index = this.props.column_section.column_format_index;
          const phoneData =
            JSON.parse(property.deal.phone_data || [])[index] || {};
          const match = phoneMatch(property, phoneData);
          return (
            <Wrapper
              style={{
                alignSelf: "stretch",
                opacity: match.match ? 1 : 0.5
              }}
            >
              <Row
                style={{
                  whiteSpace: "nowrap"
                }}
              >
                <Copy>
                  {phoneData.number
                    ? formatPhoneNumber(phoneData.number)
                    : "--"}
                </Copy>
              </Row>
              {phoneData.number && (
                <Row>
                  {match.reason ? (
                    <Copy style={{ fontSize: 10, whiteSpace: "nowrap" }}>
                      {match.reason}
                    </Copy>
                  ) : (
                    <Copy style={{ fontSize: 10, whiteSpace: "nowrap" }}>
                      {phoneData.cnam || "--"} {phoneData.type || "--"}
                    </Copy>
                  )}
                </Row>
              )}
            </Wrapper>
          );
        }
      }

      return (
        <Wrapper
          style={{
            alignSelf: "stretch"
          }}
        >
          <Row
            style={{
              whiteSpace: "nowrap"
            }}
          >
            <Copy>--</Copy>
          </Row>
        </Wrapper>
      );
    }
    switch (slug) {
      case "owner_name":
        return (
          <Copy style={{ whiteSpace: "nowrap" }}>
            {owner_info.owner_name && owner_info.owner_name !== ""
              ? owner_info.owner_name
              : "--"}
          </Copy>
        );

      case "owner_first_name":
        return (
          <Copy style={{ whiteSpace: "nowrap" }}>
            {owner_info.owner_firstname && owner_info.owner_firstname !== ""
              ? owner_info.owner_firstname
              : "--"}
          </Copy>
        );

      case "owner_last_name":
        return (
          <Copy style={{ whiteSpace: "nowrap" }}>
            {owner_info.owner_lastname && owner_info.owner_lastname !== ""
              ? owner_info.owner_lastname
              : "--"}
          </Copy>
        );

      case "owner_status":
        return (
          <Copy style={{ whiteSpace: "nowrap" }}>
            {owner_info.owner_status_info
              ? owner_info.owner_status_info.text
              : "Owner Not Found"}
          </Copy>
        );

      default:
        break;
    }

    switch (format) {
      case "name":
      case "text":
      case "company_name":
        formatted_value = toTitleCase(value);
        break;

      case "money":
      case "price":
        if (parseInt(value) !== 0 && value && value !== "") {
          formatted_value = "$" + numberFormat(parseInt(value));
        }
        break;

      case "date":
        if (value && value !== "" && value !== 0) {
          formatted_value = moment(value).format("MMM Do, YYYY");
        }
        break;

      case "percent":
        if (value && value !== 0 && value !== "0") {
          formatted_value = parseInt(parseFloat(value) * 100) + "%";
        }
        break;

      case "term":
        if (parseInt(value) > 60) {
          formatted_value = value + " Month";
        }
        break;

      case "number":
        formatted_value = numberFormat(parseInt(value));
        break;

      case "acre":
        formatted_value = parseFloat(value).toFixed(2);
        break;

      case "feet":
        formatted_value = numberFormat(parseInt(value)) + " ft";
        break;

      case "mailing_options":
        return (
          <Wrapper
            className="deal-hover-icon"
            style={{
              alignSelf: "stretch"
            }}
          >
            <Row
              style={{
                whiteSpace: "nowrap"
              }}
            >
              <Copy>
                {this.getMailingOptionsText(property.deal, property.deal)}
              </Copy>
              <Icon
                size={18}
                color={this.props.colors.light_text_color}
                icon="edit"
                style={{
                  marginLeft: 10
                }}
              />
            </Row>
          </Wrapper>
        );

      case "status":
        return (
          <Wrapper
            className="deal-hover-icon"
            style={{
              alignSelf: "stretch"
            }}
          >
            <Row
              style={{
                whiteSpace: "nowrap"
              }}
            >
              <Copy>{property.deal.deal_status_title}</Copy>
              <Icon
                size={18}
                color={this.props.colors.light_text_color}
                icon="swap-horiz"
                style={{
                  marginLeft: 10
                }}
              />
            </Row>
          </Wrapper>
        );

      case "lists":
        if (
          property.deal.lists.length > 0 &&
          Array.isArray(property.deal.lists)
        ) {
          return (
            <Wrapper
              className="deal-hover-icon"
              style={{
                alignSelf: "stretch"
              }}
            >
              <Row
                style={{
                  whiteSpace: "nowrap"
                }}
              >
                <Copy>
                  {property.deal.lists.map((list, i) => {
                    if (i === 0) {
                      return list.title;
                    }
                    return ", " + list.title;
                  })}
                </Copy>
                <Icon
                  size={18}
                  color={this.props.colors.light_text_color}
                  icon="edit"
                  style={{
                    marginLeft: 10
                  }}
                />
              </Row>
            </Wrapper>
          );
        }
        return (
          <Wrapper
            className="deal-hover-icon"
            style={{
              alignSelf: "stretch"
            }}
          >
            <Row
              style={{
                whiteSpace: "nowrap"
              }}
            >
              <Copy>--</Copy>
              <Icon
                size={18}
                color={this.props.colors.light_text_color}
                icon="edit"
                style={{
                  marginLeft: 10
                }}
              />
            </Row>
          </Wrapper>
        );

      case "phone_numbers": {
        if (property.deal.phone_numbers) {
          if (this.props.column_section.column_format == "single") {
            return (
              <Copy>
                {property.deal.phone_numbers.map((phone_number, i) => {
                  if (i === 0) {
                    return phone_number;
                  }
                  return ", " + phone_number;
                })}
              </Copy>
            );
          }
          if (
            property.deal.phone_numbers.length > 0 &&
            Array.isArray(property.deal.phone_numbers)
          ) {
            const index = this.props.column_section.column_format_index;
            const phoneData =
              JSON.parse(property.deal.phone_data || [])[index] || {};
            const match = phoneMatch(property, phoneData);
            return (
              <Wrapper
                style={{
                  alignSelf: "stretch",
                  opacity: match ? 1 : 0.5
                }}
              >
                <Row
                  style={{
                    whiteSpace: "nowrap"
                  }}
                >
                  <Copy>
                    {phoneData.number
                      ? formatPhoneNumber(phoneData.number)
                      : "--"}
                  </Copy>
                </Row>
                {phoneData.number && (
                  <Row>
                    <Copy style={{ fontSize: 10, whiteSpace: "nowrap" }}>
                      {phoneData.cnam || "--"} {phoneData.type || "--"}
                    </Copy>
                  </Row>
                )}
              </Wrapper>
            );
          }
        }

        return (
          <Wrapper
            style={{
              alignSelf: "stretch"
            }}
          >
            <Row
              style={{
                whiteSpace: "nowrap"
              }}
            >
              <Copy>--</Copy>
            </Row>
          </Wrapper>
        );
      }

      case "phone_type": {
        const index = this.props.column_section.column_format_index;
        let t = "--";
        if (index != null) {
          const phoneData =
            JSON.parse(property.deal.phone_data || [])[index] || {};
          t = phoneData.type || "--";
        }
        return (
          <Wrapper
            style={{
              alignSelf: "stretch"
            }}
          >
            <Row
              style={{
                whiteSpace: "nowrap"
              }}
            >
              <Copy>{t}</Copy>
            </Row>
          </Wrapper>
        );
      }
      case "phone_cnam": {
        const index = this.props.column_section.column_format_index;
        let t = "--";
        if (index != null) {
          const phoneData =
            JSON.parse(property.deal.phone_data || [])[index] || {};
          t = phoneData.cnam || "--";
        }
        return (
          <Wrapper
            style={{
              alignSelf: "stretch"
            }}
          >
            <Row
              style={{
                whiteSpace: "nowrap"
              }}
            >
              <Copy>{t}</Copy>
            </Row>
          </Wrapper>
        );
      }
      case "phone_connected": {
        const index = this.props.column_section.column_format_index;
        let t = "--";
        if (index != null) {
          const phoneData =
            JSON.parse(property.deal.phone_data || [])[index] || {};
          switch (phoneData.connected) {
            case 1:
              t = "Connected";
              break;
            case 0:
              t = "Not connected";
              break;
          }
        }
        return (
          <Wrapper
            style={{
              alignSelf: "stretch"
            }}
          >
            <Row
              style={{
                whiteSpace: "nowrap"
              }}
            >
              <Copy>{t}</Copy>
            </Row>
          </Wrapper>
        );
      }
      case "email_addresses":
        if (property.deal.email_addresses) {
          if (
            property.deal.email_addresses.length > 0 &&
            Array.isArray(property.deal.email_addresses)
          ) {
            return (
              <Wrapper
                style={{
                  alignSelf: "stretch"
                }}
              >
                <Row
                  style={{
                    whiteSpace: "nowrap"
                  }}
                >
                  <Copy>
                    {property.deal.email_addresses.map((email_address, i) => {
                      if (i === 0) {
                        return email_address;
                      }
                      return ", " + email_address;
                    })}
                  </Copy>
                </Row>
              </Wrapper>
            );
          }
        }
        return (
          <Wrapper
            style={{
              alignSelf: "stretch"
            }}
          >
            <Row
              style={{
                whiteSpace: "nowrap"
              }}
            >
              <Copy>--</Copy>
            </Row>
          </Wrapper>
        );

      case "tags":
        if (property.deal.tags) {
          if (
            property.deal.tags.length > 0 &&
            Array.isArray(property.deal.tags)
          ) {
            return (
              <Wrapper
                className="deal-hover-icon"
                style={{
                  alignSelf: "stretch"
                }}
              >
                <Row
                  style={{
                    whiteSpace: "nowrap"
                  }}
                >
                  <Copy>
                    {property.deal.tags.map((tag, i) => {
                      if (i === 0) {
                        return tag.title;
                      }
                      return ", " + tag.title;
                    })}
                  </Copy>
                  <Icon
                    size={18}
                    color={this.props.colors.light_text_color}
                    icon="edit"
                    style={{
                      marginLeft: 10
                    }}
                  />
                </Row>
              </Wrapper>
            );
          }
        }
        return (
          <Wrapper
            className="deal-hover-icon"
            style={{
              alignSelf: "stretch"
            }}
          >
            <Row
              style={{
                whiteSpace: "nowrap"
              }}
            >
              <Copy>--</Copy>
              <Icon
                size={18}
                color={this.props.colors.light_text_color}
                icon="edit"
                style={{
                  marginLeft: 10
                }}
              />
            </Row>
          </Wrapper>
        );

      case "address":
        switch (slug) {
          case "property_address":
          default:
            const display_property = determineDisplayProperty(property);

            return (
              <Wrapper>
                <Copy
                  style={{
                    whiteSpace: "nowrap"
                  }}
                >
                  {
                    formatAddress({
                      address: {
                        address: display_property.property_address,
                        address2: display_property.property_address2,
                        address_city: display_property.property_address_city,
                        address_state: display_property.property_address_state,
                        address_zip: display_property.property_address_zip
                      }
                    }).line1
                  }
                </Copy>
                <Copy style={{ fontSize: 10, whiteSpace: "nowrap" }}>
                  {
                    formatAddress({
                      address: {
                        address: display_property.property_address,
                        address2: display_property.property_address2,
                        address_city: display_property.property_address_city,
                        address_state: display_property.property_address_state,
                        address_zip: display_property.property_address_zip
                      }
                    }).line2
                  }
                </Copy>
              </Wrapper>
            );

          case "owner_address":
            if (owner_info.owner_address && owner_info.owner_address !== "") {
              return (
                <Wrapper>
                  <Copy
                    style={{
                      whiteSpace: "nowrap"
                    }}
                  >
                    {
                      formatAddress({
                        address: {
                          address: owner_info.owner_address,
                          address2: owner_info.owner_address2,
                          address_city: owner_info.owner_address_city,
                          address_state: owner_info.owner_address_state,
                          address_zip: owner_info.owner_address_zip
                        }
                      }).line1
                    }
                  </Copy>
                  <Copy style={{ fontSize: 10, whiteSpace: "nowrap" }}>
                    {
                      formatAddress({
                        address: {
                          address: owner_info.owner_address,
                          address2: owner_info.owner_address2,
                          address_city: owner_info.owner_address_city,
                          address_state: owner_info.owner_address_state,
                          address_zip: owner_info.owner_address_zip
                        }
                      }).line2
                    }
                  </Copy>
                </Wrapper>
              );
            }
            return <Copy>--</Copy>;
        }

      default:
        if (value && value !== 0 && value !== "0" && value !== "") {
          formatted_value = value;
        }
        break;
    }

    return (
      <Copy
        style={{
          whiteSpace: "nowrap"
        }}
      >
        {formatted_value}
      </Copy>
    );
  }

  renderPreviewButton(property) {
    if (this.props.column_section.main_column === true) {
      return (
        <Wrapper
          className="deal-preview"
          style={{
            position: "absolute",
            right: 0,
            width: this.props.toggle_lead_images ? "100%" : "auto",
            backgroundColor: this.props.toggle_lead_images
              ? this.props.dark_mode == "dark_mode"
                ? "rgba(31,41,51, 0.25)"
                : "rgba(255, 255, 255, 0.75)"
              : this.props.colors.card_color,
            margin: this.props.toggle_lead_images ? 0 : 10,
            height: this.props.toggle_lead_images
              ? "100%"
              : this.state.row_height,
            alignItems: "flex-end",
            justifyContent: "center"
          }}
        >
          <Row>
            <Button
              onPress={() => {
                this.props.pressProperty(property);
              }}
              style={{
                alignItems: "center",
                justifyContent: "center",
                borderWidth: 1,
                borderColor: this.props.colors.border_color,
                backgroundColor: this.props.colors.card_color,
                borderStyle: "solid",
                borderRadius: 5,
                marginLeft: 5,
                padding: 5
              }}
            >
              <Copy style={{}}>View Lead</Copy>
            </Button>
            {!property.deal.updating || !property.deal.updating.is_updating ? (
              <Button
                onPress={() => {
                  if (property.deal) {
                    if (
                      this.props.user.team_clearance_level > 1 ||
                      parseInt(this.props.user.can_send_mail) === 1
                    ) {
                      if (property.deal.deal_status_slug === "with_marketing") {
                        //pause mailers

                        this.props.updateLead({
                          token: this.props.token,
                          type: "pause_mailers",
                          deal_ids: property.deal.id,
                          onSuccess: () => {}
                        });
                      } else {
                        //start mailers

                        this.props.updateLead({
                          token: this.props.token,
                          type: "start_mailers",
                          deal_ids: property.deal.id,
                          onSuccess: () => {}
                        });
                      }
                    } else {
                      this.props.setModal({
                        title:
                          "You do not have permissions to do start mailers.",
                        description:
                          "Talk to your team owner to get the permissions you need.",
                        icon: "error",
                        submit: "Dismiss",
                        onPress: () => {},
                        cancel: "",
                        onCancel: () => {}
                      });
                      this.props.toggleModal({ show: true, type: "normal" });
                    }
                  }
                }}
                style={{
                  alignItems: "center",
                  justifyContent: "center",
                  borderWidth: 1,
                  borderColor: this.props.colors.border_color,
                  borderStyle: "solid",
                  borderRadius: 5,
                  marginLeft: 5,
                  marginRight: this.props.toggle_lead_images ? 10 : 0,
                  padding: 5,
                  backgroundColor: property.deal
                    ? property.deal.deal_status_slug === "with_marketing"
                      ? this.props.colors.card_color
                      : this.props.colors.active_color
                    : this.props.colors.active_color
                }}
              >
                <Copy
                  style={{
                    color: property.deal
                      ? property.deal.deal_status_slug === "with_marketing"
                        ? "inherit"
                        : this.props.colors.white_text_color
                      : this.props.colors.white_text_color
                  }}
                >
                  {property.deal
                    ? property.deal.deal_status_slug === "with_marketing"
                      ? parseInt(property.deal.campaign_id) !== 0
                        ? "Pause Campaign"
                        : "Pause Mailers"
                      : parseInt(property.deal.campaign_id) !== 0
                      ? "Start Campaign"
                      : "Start Mailers"
                    : "Start Mailers"}
                </Copy>
              </Button>
            ) : null}
          </Row>
        </Wrapper>
      );
    } else if (
      (this.props.column_section.format === "phone_numbers" ||
        this.props.column_section.format === "email_addresses") &&
      property.deal.did_skip_trace !== 1 &&
      (!property.deal.updating || !property.deal.updating.is_updating)
    ) {
      return (
        <Wrapper
          className="deal-preview"
          style={{
            position: "absolute",
            right: 0,
            backgroundColor: this.props.colors.card_color,
            margin: 10,
            height: this.state.row_height,
            alignItems: "center",
            justifyContent: "center"
          }}
        >
          <Row>
            <Button
              onPress={() => {
                if (property.deal) {
                  if (
                    this.props.user.team_clearance_level > 1 ||
                    parseInt(this.props.user.can_enhanced_search) === 1
                  ) {
                    skipTrace({
                      props: this.props,
                      properties: [property],
                      total_property_count: 1,
                      onSuccess: () => {}
                    });
                  } else {
                    this.props.setModal({
                      title: "You do not have permissions to use skip tracing.",
                      description:
                        "Talk to your team owner to get the permissions you need.",
                      icon: "error",
                      submit: "Dismiss",
                      onPress: () => {},
                      cancel: "",
                      onCancel: () => {}
                    });
                    this.props.toggleModal({ show: true, type: "normal" });
                  }
                }
              }}
              style={{
                alignItems: "center",
                justifyContent: "center",
                borderWidth: 1,
                borderColor: this.props.colors.border_color,
                borderStyle: "solid",
                borderRadius: 5,
                marginLeft: 5,
                padding: 5
              }}
            >
              <Copy> Skip Trace </Copy>
            </Button>
          </Row>
        </Wrapper>
      );
    }
  }

  renderLoading(property) {
    if (
      property &&
      property.deal &&
      property.deal.updating &&
      property.deal.updating.is_updating
    ) {
      return (
        <Wrapper
          style={{
            position: "absolute",
            top: 0,
            right: 0,
            left: 0,
            bottom: 0,
            width: "100%",
            height: "100%",
            alignItems: "flex-start",
            justifyContent: "center",
            backgroundColor: this.props.colors.white_color_opacity
          }}
        >
          {this.props.column_section.main_column ? (
            <Row>
              <Copy
                style={{
                  marginLeft: 5,
                  color: this.props.colors.light_text_color,
                  size: 12
                }}
              ></Copy>
            </Row>
          ) : null}
        </Wrapper>
      );
    }
  }

  renderListButton(property, i) {
    if (
      this.state.temp_item &&
      this.state.temp_item_id ===
        this.props.column_section.slug + "_" + property.deal.id
    ) {
      return (
        <Wrapper
          style={{
            padding: 10,
            height: this.state.row_height,

            borderRightWidth:
              this.props.last_column || this.props.column_section.main_column
                ? 1
                : 0,
            borderRightColor: this.props.colors.border_color,
            borderRightStyle: "solid",
            backgroundColor: this.props.active_property
              ? property.id === this.props.active_property.id
                ? this.props.colors.background_color
                : this.props.colors.card_color
              : this.props.colors.card_color
          }}
        >
          <Wrapper
            style={{
              flex: 1,
              alignItems: "flex-start",
              justifyContent: "center",
              overflow: "hidden"
            }}
          >
            <Copy style={{ whiteSpace: "nowrap" }}>
              {this.state.temp_item.title}
            </Copy>
          </Wrapper>
          {this.renderLoading(property)}
        </Wrapper>
      );
    }

    return (
      <Wrapper
        key={i}
        style={{
          position: "relative",
          width: this.props.column_section.width
        }}
      >
        <Button
          style={{
            width: this.props.column_section.width,
            overflow: "hidden",
            whiteSpace: "nowrap"
          }}
          onPress={() => {
            switch (this.props.column_section.format) {
              case "status":
                this.props.setStatusModal({
                  title: "Edit Lead Status",
                  description:
                    "Select a new status for " +
                    property.property_address +
                    ".",
                  type: "edit_status_for_lead",
                  selected_leads: [property],
                  selected_status: property.deal.deal_status_id,
                  modalAction: ({ selected_leads, selected_status }) => {
                    //trigger add to list
                    this.props.updateLead({
                      token: this.props.token,
                      type: "edit_status_for_lead",
                      deal_status: selected_status,
                      deal_ids: selected_leads
                        .map(property => {
                          return property.deal.id;
                        })
                        .join(),
                      onSuccess: () => {
                        this.updateTempItem();
                      }
                    });
                  },
                  popoverTarget: !this.props.isMobile
                    ? this._row_refs && property.deal
                      ? this._row_refs[this.props.column_section.slug]
                        ? this._row_refs[this.props.column_section.slug][
                            property.deal.id
                          ]
                          ? this._row_refs[this.props.column_section.slug][
                              property.deal.id
                            ].current
                          : null
                        : null
                      : null
                    : null,
                  popoverPlacement: "right",
                  cancelAction: () => {
                    this.updateTempItem();
                  },
                  fieldsUpdated: fields => {
                    this.updateTempItem(
                      this.props.column_section.slug + "_" + property.deal.id,
                      { title: fields.status_title }
                    );
                  }
                });

                this.props.appRedirect({
                  redirect: "goForward",
                  payload: { add: "lead-status" }
                });

                break;

              case "lists":
                this.props.setListModal({
                  title: "Edit List(s)",
                  description:
                    "Choose a list or mulitple lists to add " +
                    property.property_address +
                    ".",
                  type: "edit_lists_for_lead",
                  selected_leads: [property],
                  selected_lists: property.deal.lists,
                  modalAction: ({ selected_leads, selected_lists }) => {
                    //trigger add to list
                    this.props.updateLead({
                      token: this.props.token,
                      type: "edit_lists_for_lead",
                      list_ids: selected_lists
                        .map(list => {
                          return list.id;
                        })
                        .join(),
                      deal_ids: selected_leads
                        .map(property => {
                          return property.deal.id;
                        })
                        .join(),
                      onSuccess: () => {
                        this.updateTempItem();
                      }
                    });
                  },
                  popoverTarget: !this.props.isMobile
                    ? this._row_refs && property.deal
                      ? this._row_refs[this.props.column_section.slug]
                        ? this._row_refs[this.props.column_section.slug][
                            property.deal.id
                          ]
                          ? this._row_refs[this.props.column_section.slug][
                              property.deal.id
                            ].current
                          : null
                        : null
                      : null
                    : null,
                  popoverPlacement: "right",
                  cancelAction: () => {
                    this.updateTempItem();
                  },
                  fieldsUpdated: fields => {
                    this.updateTempItem(
                      this.props.column_section.slug + "_" + property.deal.id,
                      {
                        title:
                          fields.length === 0
                            ? "--"
                            : fields.map((list, i) => {
                                if (i === fields.length - 1) {
                                  return list.title;
                                }
                                return list.title + ", ";
                              })
                      }
                    );
                  }
                });

                this.props.appRedirect({
                  redirect: "goForward",
                  payload: { add: "lists" }
                });
                break;

              case "tags":
                this.props.setTagModal({
                  title: "Edit Tag(s)",
                  description:
                    "Choose a tag or mulitple tags to add " +
                    property.property_address +
                    ".",
                  type: "edit_tags_for_lead",
                  selected_leads: [property],
                  selected_tags: property.deal.tags,
                  modalAction: ({ selected_leads, selected_tags }) => {
                    //trigger add to list
                    this.props.updateLead({
                      token: this.props.token,
                      type: "edit_tags_for_lead",
                      tag_ids: selected_tags
                        .map(tag => {
                          return tag.id;
                        })
                        .join(),
                      deal_ids: selected_leads
                        .map(property => {
                          return property.deal.id;
                        })
                        .join(),
                      onSuccess: () => {
                        this.updateTempItem();
                      }
                    });
                  },
                  popoverTarget: !this.props.isMobile
                    ? this._row_refs && property.deal
                      ? this._row_refs[this.props.column_section.slug]
                        ? this._row_refs[this.props.column_section.slug][
                            property.deal.id
                          ]
                          ? this._row_refs[this.props.column_section.slug][
                              property.deal.id
                            ].current
                          : null
                        : null
                      : null
                    : null,
                  popoverPlacement: "right",
                  cancelAction: () => {
                    this.updateTempItem();
                  },
                  fieldsUpdated: fields => {
                    this.updateTempItem(
                      this.props.column_section.slug + "_" + property.deal.id,
                      {
                        title:
                          fields.length === 0
                            ? "--"
                            : fields.map((tag, i) => {
                                if (i === fields.length - 1) {
                                  return tag.title;
                                }
                                return tag.title + ", ";
                              })
                      }
                    );
                  }
                });

                this.props.appRedirect({
                  redirect: "goForward",
                  payload: { add: "tags" }
                });
                break;

              case "mailing_options":
                this.props.setEditModal({
                  title: "Edit Mailing Options",
                  description:
                    "Edit mailing options for " + property.property_address,
                  slug: "mailing-options",
                  type: "edit_mailing_options",
                  fields: {
                    start_mailers:
                      parseInt(property.deal.approved) === 1 ? 1 : 0,
                    template_id: property.deal.mail_template_id,
                    template_name: property.deal.mail_template_name,
                    campaign_id: property.deal.campaign_id,
                    campaign_title: property.deal.campaign_title,

                    resend_freq: parseInt(property.deal.resend_freq),
                    resend_freq_switch:
                      property.deal.resend_freq > 0 ? "on" : "off",
                    resend_limit: parseInt(property.deal.resend_limit),
                    resend_limit_switch:
                      parseInt(property.deal.resend_limit) === 0 ? "on" : "off"
                  },
                  save_button_text: "Edit Mailing Options",
                  modalAction: ({ fields }) => {
                    this.props.updateLead({
                      token: this.props.token,
                      type: "edit_mailing_options_for_leads",
                      start_mailers: fields.start_mailers,
                      campaign_id: fields.campaign_id,
                      mail_template_id:
                        parseInt(fields.campaign_id) !== 0 &&
                        fields.campaign_id != null
                          ? 0
                          : fields.template_id,
                      resend_freq:
                        parseInt(fields.campaign_id) !== 0 &&
                        fields.campaign_id != null
                          ? 0
                          : fields.resend_freq_switch === "off"
                          ? 0
                          : fields.resend_freq,
                      resend_limit:
                        parseInt(fields.campaign_id) !== 0 &&
                        fields.campaign_id != null
                          ? 0
                          : fields.resend_limit_switch === "on"
                          ? 0
                          : fields.resend_limit,
                      deal_ids: property.deal.id,
                      onSuccess: () => {
                        this.updateTempItem();
                      }
                    });
                  },
                  popoverTarget: !this.props.isMobile
                    ? this._row_refs && property.deal
                      ? this._row_refs[this.props.column_section.slug]
                        ? this._row_refs[this.props.column_section.slug][
                            property.deal.id
                          ]
                          ? this._row_refs[this.props.column_section.slug][
                              property.deal.id
                            ].current
                          : null
                        : null
                      : null
                    : null,
                  popoverPlacement: "right",
                  cancelAction: () => {
                    this.updateTempItem();
                  },
                  fieldsUpdated: fields => {
                    this.updateTempItem(
                      this.props.column_section.slug + "_" + property.deal.id,
                      {
                        title: this.getMailingOptionsText(fields, property.deal)
                      }
                    );
                  }
                });

                this.props.appRedirect({
                  redirect: "goForward",
                  payload: { add: "mailing-options" }
                });

                break;

              default:
                this.props.pressProperty(property);
                break;
            }
          }}
        >
          <Wrapper
            style={{ position: "relative" }}
            className={
              this.props.column_section.main_column ||
              this.props.column_section.format === "phone_numbers" ||
              this.props.column_section.format === "email_addresses"
                ? "deal-hover-preview"
                : "deal-hover-icon"
            }
          >
            <Row
              style={{
                padding: 10,
                paddingLeft:
                  this.props.column_section.main_column &&
                  this.props.toggle_lead_images
                    ? 0
                    : 10,
                height: this.state.row_height,
                borderRightWidth:
                  this.props.last_column ||
                  this.props.column_section.main_column
                    ? 1
                    : 0,
                borderRightColor: this.props.colors.border_color,
                borderRightStyle: "solid",
                backgroundColor: this.props.active_property
                  ? property.id === this.props.active_property.id
                    ? this.props.colors.background_color
                    : this.props.colors.card_color
                  : this.props.colors.card_color
              }}
            >
              {this.renderMainColumnImage(property)}
              <Wrapper
                style={{
                  flex: 1,
                  alignItems: "flex-start",
                  justifyContent: "center"
                }}
              >
                {this.props.column_section.deal && property.deal
                  ? this.renderItemFormat(
                      property.deal[this.props.column_section.slug],
                      this.props.column_section.slug,
                      this.props.column_section.format,
                      property
                    )
                  : this.renderItemFormat(
                      property[this.props.column_section.slug],
                      this.props.column_section.slug,
                      this.props.column_section.format,
                      property
                    )}
              </Wrapper>
            </Row>
            {this.renderLoading(property)}
            {this.renderPreviewButton(property)}
          </Wrapper>
        </Button>
      </Wrapper>
    );
  }

  render() {
    if (this.props.column_section) {
      return (
        <Wrapper style={{ width: this.props.column_section.width }}>
          {this.props.header_only ? (
            <ItemHeader
              column_width={this.props.column_section.width}
              adjustColumnWidth={this.adjustColumnWidth}
              resize={true}
              section={this.props.column_section}
              last_column={this.props.last_column}
              {...this.props}
            />
          ) : null}

          {!this.props.header_only &&
            this.props.list_properties.map((property, i) => {
              if (property.deal && property.deal.removed != 1) {
                if (
                  this.props.column_section.format === "status" ||
                  this.props.column_section.format === "lists" ||
                  this.props.column_section.format === "tags" ||
                  this.props.column_section.format === "mailing_options" ||
                  this.props.column_section.format === "phone_numbers" ||
                  this.props.column_section.format === "email_addresses" ||
                  this.props.column_section.main_column
                ) {
                  return (
                    <Wrapper
                      key={i}
                      wrapper_ref={
                        this._row_refs
                          ? this._row_refs[this.props.column_section.slug] &&
                            property.deal
                            ? this._row_refs[this.props.column_section.slug][
                                property.deal.id
                              ]
                              ? this._row_refs[this.props.column_section.slug][
                                  property.deal.id
                                ]
                              : null
                            : null
                          : null
                      }
                    >
                      {this.renderListButton(property, i)}
                    </Wrapper>
                  );
                }
                return (
                  <Wrapper
                    key={i}
                    style={{
                      width: this.props.column_section.width,
                      overflow: "hidden",
                      position: "relative"
                    }}
                  >
                    <Row
                      style={{
                        padding: 10,

                        height: this.state.row_height,
                        borderRightWidth:
                          this.props.last_column ||
                          this.props.column_section.main_column
                            ? 1
                            : 0,
                        borderRightColor: this.props.colors.border_color,
                        borderRightStyle: "solid",
                        backgroundColor: this.props.active_property
                          ? property.id === this.props.active_property.id
                            ? this.props.colors.background_color
                            : this.props.colors.card_color
                          : this.props.colors.card_color
                      }}
                    >
                      <Wrapper
                        style={{
                          flex: 1,
                          alignItems: "flex-start",
                          justifyContent: "center"
                        }}
                      >
                        {this.props.column_section.deal &&
                        property.deal &&
                        property.deal != 1
                          ? this.renderItemFormat(
                              property.deal[this.props.column_section.slug],
                              this.props.column_section.slug,
                              this.props.column_section.format,
                              property
                            )
                          : this.renderItemFormat(
                              property[this.props.column_section.slug],
                              this.props.column_section.slug,
                              this.props.column_section.format,
                              property
                            )}
                      </Wrapper>
                    </Row>
                    {this.renderLoading(property)}
                  </Wrapper>
                );
              }
            })}
        </Wrapper>
      );
    }
  }
}

export default PropertyItemAddresses;
